(() => {
  const sections = document.querySelectorAll('[data-sccp]');

  const formatMoney = (cents) => {
    const amount = Number(cents || 0) / 100;
    const currency = window.Shopify?.currency?.active || 'GBP';

    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency,
        minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
        maximumFractionDigits: Number.isInteger(amount) ? 0 : 2
      }).format(amount);
    } catch (_error) {
      return `\u00a3${Number.isInteger(amount) ? amount : amount.toFixed(2)}`;
    }
  };

  sections.forEach((section) => {
    const variantsScript = section.querySelector('[data-sccp-variants]');
    const variants = variantsScript ? JSON.parse(variantsScript.textContent || '[]') : [];
    const form = section.querySelector('[data-sccp-form]');
    const variantInput = section.querySelector('[data-sccp-variant-input]');
    const optionSelects = Array.from(section.querySelectorAll('[data-sccp-option-select]'));
    const priceNodes = section.querySelectorAll('[data-sccp-price]');
    const atc = section.querySelector('[data-sccp-atc]');
    const atcLabel = section.querySelector('[data-sccp-atc-label]');
    const atcPrice = section.querySelector('[data-sccp-atc-price]');
    const message = section.querySelector('[data-sccp-message]');
    const qtyInput = section.querySelector('[data-sccp-quantity-input]');
    const minus = section.querySelector('[data-sccp-qty-minus]');
    const plus = section.querySelector('[data-sccp-qty-plus]');
    const finalAtc = section.querySelector('[data-sccp-final-atc]');
    const heroImage = section.querySelector('.sccp__hero-image img');
    const thumbs = section.querySelectorAll('[data-sccp-thumb]');
    const details = section.querySelectorAll('[data-sccp-responsive-detail]');
    const mobileQuery = window.matchMedia('(max-width: 989px)');
    const reviewTrack = section.querySelector('[data-sccp-review-track]');
    const reviewPrev = section.querySelector('[data-sccp-review-prev]');
    const reviewNext = section.querySelector('[data-sccp-review-next]');
    const soldOutLabel = atc?.dataset.sccpSoldOutLabel || 'Sold out';
    const defaultCta = atc?.dataset.sccpAvailableLabel || atcLabel?.textContent?.trim() || 'Add to basket';
    let isAdding = false;

    const selectedOptions = () => optionSelects.map((select) => select.value);

    const getSelectedVariant = () => {
      if (!variants.length) return null;
      if (!optionSelects.length) return variants[0];

      return variants.find((variant) => {
        return selectedOptions().every((value, index) => variant.options[index] === value);
      }) || variants[0];
    };

    const getQuantity = () => {
      const quantity = parseInt(qtyInput?.value || '1', 10);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    };

    const updatePurchaseState = () => {
      const variant = getSelectedVariant();
      if (!variant) return;

      const quantity = getQuantity();
      const linePrice = variant.price * quantity;

      if (variantInput) variantInput.value = variant.id;
      priceNodes.forEach((node) => {
        node.textContent = variant.priceFormatted || formatMoney(variant.price);
      });
      if (atcPrice) atcPrice.textContent = formatMoney(linePrice);
      if (atcLabel && !isAdding) atcLabel.textContent = variant.available ? defaultCta : soldOutLabel;
      if (atc) atc.disabled = isAdding || !variant.available;
    };

    const setMessage = (text) => {
      if (message) message.textContent = text || '';
    };

    const setLoading = (loading) => {
      isAdding = loading;
      if (atc) atc.classList.toggle('is-loading', loading);
      if (atcLabel) atcLabel.textContent = loading ? 'Adding...' : defaultCta;
      updatePurchaseState();
    };

    const cartTarget = () => document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    const cartSections = () => {
      const cart = cartTarget();
      if (cart && typeof cart.getSectionsToRender === 'function') {
        return cart.getSectionsToRender().map((renderSection) => renderSection.id).filter(Boolean);
      }

      return ['cart-drawer', 'cart-icon-bubble', 'cart-notification-product', 'cart-notification-button'];
    };

    const renderCart = (cartState) => {
      const cart = cartTarget();

      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cartState } }));
      document.dispatchEvent(new CustomEvent('ajaxCart:updated', { bubbles: true, detail: { cart: cartState } }));

      if (cart && cart.classList?.contains('is-empty')) {
        cart.classList.remove('is-empty');
      }

      if (cart && cartState?.sections && typeof cart.renderContents === 'function') {
        cart.renderContents(cartState);
        if (typeof cart.open === 'function') cart.open();
        return;
      }

      if (cart && typeof cart.open === 'function') {
        cart.open();
      }
    };

    const addToCart = (event) => {
      event?.preventDefault();
      if (isAdding) return;

      const variant = getSelectedVariant();
      if (!variant || !variant.available) {
        setMessage('This date and session is not available.');
        return;
      }

      const rootPath = window.Shopify?.routes?.root || '/';
      const cart = cartTarget();
      if (cart && typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }

      setMessage('');
      setLoading(true);

      fetch(`${rootPath}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variant.id,
            quantity: getQuantity()
          }],
          sections: cartSections().join(','),
          sections_url: window.location.pathname
        })
      })
        .then((response) => response.json().then((json) => {
          if (!response.ok) throw json;
          return json;
        }))
        .then((cartState) => {
          setMessage('Added to basket.');
          renderCart(cartState);
        })
        .catch((error) => {
          setMessage(error?.description || error?.message || 'Unable to add this session. Please try again.');
        })
        .finally(() => {
          setLoading(false);
        });
    };

    form?.addEventListener('submit', addToCart);

    optionSelects.forEach((select) => {
      select.addEventListener('change', updatePurchaseState);
    });

    minus?.addEventListener('click', () => {
      const nextValue = Math.max(1, getQuantity() - 1);
      qtyInput.value = nextValue;
      updatePurchaseState();
    });

    plus?.addEventListener('click', () => {
      qtyInput.value = getQuantity() + 1;
      updatePurchaseState();
    });

    qtyInput?.addEventListener('input', updatePurchaseState);

    finalAtc?.addEventListener('click', () => {
      addToCart();
    });

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!heroImage || !thumb.dataset.image) return;
        heroImage.src = thumb.dataset.image;
        heroImage.removeAttribute('srcset');
        heroImage.alt = thumb.dataset.alt || heroImage.alt;
        thumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));
      });
    });

    const syncDetails = () => {
      details.forEach((detail) => {
        if (mobileQuery.matches) {
          detail.removeAttribute('open');
        } else {
          detail.setAttribute('open', '');
        }
      });
    };

    syncDetails();
    mobileQuery.addEventListener('change', syncDetails);

    const scrollReview = (direction) => {
      if (!reviewTrack) return;
      reviewTrack.scrollBy({
        left: direction * reviewTrack.clientWidth,
        behavior: 'smooth'
      });
    };

    reviewPrev?.addEventListener('click', () => scrollReview(-1));
    reviewNext?.addEventListener('click', () => scrollReview(1));

    updatePurchaseState();
  });
})();
